<template>
  <div class="background-white form">
    <div class="container">
      <van-field v-model="username" label="收货人" maxlength="10" placeholder="请填写收货人姓名" />
      <van-field
        v-model="phone"
        type="number"
        maxlength="11"
        label="电话号码"
        placeholder="请填写收货人手机号"
      />
      <van-field
        readonly
        clickable
        name="area"
        :value="value"
        label="所在地区"
        placeholder="省市区县，乡镇等"
        @click="showPicker = true"
      />
      <van-field
        v-model="address"
        rows="1"
        autosize
        label="详细地址"
        type="textarea"
        maxlength="50"
        placeholder="街道，楼牌号等"
      />
      <van-cell center>
        <template #title>
          <div class="checked-title">设为默认地址</div>
          <div class="checked-text">每次下单时默认使用该地址</div>
        </template>
        <template #right-icon>
          <van-switch v-model="checked" size="24" inactive-color="#EBECF0" active-color="#13bf80" />
        </template>
      </van-cell>
    </div>

    <div class="bottom-fixed-button">
      <div class="container">
        <van-button round type="primary" class="button" @click="submit">保存</van-button>
      </div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import * as verification from '@/utils/verification'
import { addressEdit, addressCreate, addressDetail,getTreeList } from '@/api/address'

export default {
  data() {
    return {
      username: '',
      phone: '',
      address: '',
      value: '',
      code: '',

      showPicker: false,
      checked: false,

      columns: [],

      addressid: 0,
    }
  },
  computed: {},

  methods: {
    toastMsg(msg) {
      this.$toast(msg)
    },

    // 提交请求
    submitRquest(data) {
      let addressid = this.addressid,
        req = addressid ? addressEdit : addressCreate //如果有id就执行编辑接口，否则创建

      if (addressid) {
        data.id = addressid
      }

      req(data).then(() => {
        this.$router.go(-1) //返回上一层
      })
    },
    submit() {
      let verificationPhoneResult = verification.verifyPhone(this.phone),
        { username, address } = this
      if (!username) {
        this.toastMsg('请输入收货人信息')
        return false
      }
      if (!verificationPhoneResult.result) {
        this.toastMsg(verificationPhoneResult.msg)
        return false
      }
      if (!address) {
        this.toastMsg('请输入详细地址')
        return false
      }
      let query = this.routeFixedParam()
      query.consignee = this.username
      query.phone = this.phone
      query.address = this.address
      query.text = this.value
      query.code = this.code
      query.default = this.checked ? 1 : 0

      this.submitRquest(query)
    },
    onConfirm(pickerValue, indexes) {
      this.value = pickerValue.join('')
      const selectedIds = []
      let options = this.columns

      indexes.forEach((index) => {
        const option = options[index]
        if (!option) return

        selectedIds.push(option.value)
        options = option.children || []
      })

      this.code = selectedIds.join(',')
      this.showPicker = false
    },


    getAddressDetail() {
      let addressid = this.addressid
      addressDetail(this.routeFixedParam({ id: addressid })).then((res) => {
        let resData = res.data
        this.username = resData.consignee
        this.phone = resData.phone
        this.address = resData.address
        this.value = resData.text
        this.code = resData.code || ''
        this.checked = resData.default === 1 ? true : false
      })
    },
    // 获取省市区
    getTreeListRequest() {
      getTreeList().then((res) => {
        if (res.data && res.data.data) {
          // 1. 处理省 (过滤掉 id 为 100000 的国家级选项)
          const provinces = Object.values(res.data.data).filter(i => i.area_name && i.id != 100000)
          
          this.columns = provinces.map((item1) => ({
            text: item1.area_name,
            value: item1.id,
            // 2. 处理市
            children: Object.values(item1.child || {}).filter(i => i.area_name).map((item2) => {
              const node = {
                text: item2.area_name,
                value: item2.id,
              }
              // 3. 处理区
              const areaData = Object.values(item2.child || {}).filter(i => i.area_name)
              if (areaData.length > 0) {
                node.children = areaData.map((item3) => ({
                  text: item3.area_name,
                  value: item3.id,
                }))
              }
              return node
            }),
          }))
        }
      })
    },
  },

  created() {
    let addressid = this.$route.query.addressid

    if (addressid) {
      this.addressid = addressid
      this.getAddressDetail()
    }
    this.getTreeListRequest()
  },
}
</script>

<style lang="scss" scoped>
.checked {
  &-text {
    font-size: 0.32rem;
  }
}

.van-cell {
  padding: 0.4rem 0;

  &::after {
    width: 100%;
    left: 0;
  }
}

/deep/ .van-picker__confirm {
  color: var(--main-color);
}

/deep/ .van-switch {
  border-color: transparent;

  .van-switch__node {
    box-shadow: none;
  }
}

/deep/.van-field {
  &__label {
    color: #333;

    font-size: 0.4rem;
  }

  &__label {
    width: 2.08rem;
    margin-right: 0;
  }

  &__control {
    font-size: 0.4rem;
  }
}

.bottom-fixed-button {
  @include maxWidth();

  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  z-index: 1;

  .button {
    margin: 0.64rem 0;
  }
}

.form {
  padding-top: 0.5rem;
}
</style>
